export default __webpack_public_path__ + "static/media/django.c340192e.svg";